import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get customerType
export const getCustomerType = createAsyncThunk("customerType/getCustomerType", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCustomerType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all customerType
export const getAllCustomerType = createAsyncThunk(
  "customerType/getAllCustomerType",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllCustomerType();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("customerType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("customerType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "customerType/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageCustomerType({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create customerType
export const createCustomerType = createAsyncThunk(
  "customerType/createCustomerType",
  async (data, { rejectWithValue }) => {
    const { name, isActive } = data;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.createCustomerType(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateCustomerType = createAsyncThunk(
  "customerType/updateCustomerType",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, isActive } = values;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.updateCustomerType(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("customerType/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
